import * as apiContract from '@/api/contract'
import { formatDateKanji, applicationNoIssuing, commonErrorMessage } from '@/util/common'
import * as _ from 'lodash'
// import * as 

const getDefaultState = () => {
  const defaults = {
    lists: [],
    options: {
      payment: null,
      charge_name: ''
    },
    calculation: [],
    paymentList: null,
    visiblePopup: null
  }
  return defaults
}

const purchase = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    edited: state => _.filter(state.lists, list => list.edited && list.purchase > 0),
    getPurchaseList: (state, getters) => _.map(getters.edited, list => {
      return {
        code: list.code,
        num: list.purchase
      }
    }),
    applicationNo: state => applicationNoIssuing(state.paymentList.application_no)
  },
  mutations: {
    setDefaultPayment(state, value) {
      state.options.payment = value
    },
    setDefaultLists(state, value) {
      state.lists = value
    },
    setPurchase(state, { index, selected }) {
      const prev = state.lists[index]
      prev.purchase = selected
      prev.edited = true
      state.lists.splice(index, 1, prev)
    },
    buyPurchase(state, index) {
      const prev = state.lists[index]
      prev.edited = true
      state.lists.splice(index, 1, prev)
    },
    resetPurchase(state, index) {
      const prev = state.lists[index]
      prev.purchase = 0
      prev.edited = false
      state.lists.splice(index, 1, prev)
    },
    setCalculation(state, purchaseList) {
      state.calculation = purchaseList
    },
    setPurchaseConfirm(state, paymentList) {
      state.paymentList = paymentList
    },
    setPurchaseComplete(state, paymentList) {
      state.paymentList = paymentList
    },
    setVisiblePopup(state, value) {
      state.visiblePopup = value
    },
    resetAllState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    // 既定の支払い方法変更
    setDefaultPayment({ rootState, commit }) {
      commit('setDefaultPayment', rootState.contract.default_payment)
    },
    // 商品のリストを生成
    async setDefaultLists({ commit, rootGetters }) {
      const signedNewPackageProduct = rootGetters['contractPack/signedNewPackageProduct']
      const unsignedNewPackageProduct = rootGetters['contractPack/unsignedNewPackageProduct']
      const lists = _.map([...signedNewPackageProduct, ...unsignedNewPackageProduct], product => {
        product.purchase = 0
        product.edited = false
        return product
      })
      // const lists = _.forEach([...signedNewPackageProduct, ...unsignedNewPackageProduct], product => _.set(_.set(product, 'purchase', 0), 'edited', false))

      // 販売停止になっているものを除外する
      const result = _.reject(lists, product => product.package_master_status === 4 || product.product_master_status === 6)

      await commit('setDefaultLists', result)
    },
    // 購入数を指定
    changePurchase({ commit }, { index, selected }) {
      commit('setPurchase', { index, selected })
    },
    // 購入ボタン押下
    buyPurchase({ commit }, index) {
      commit('buyPurchase', index)
    },
    // リセットボタン押下
    resetPurchase({ commit }, index) {
      commit('resetPurchase', index)
    },
    // 購入情報をセット
    async setCalculation({ commit, getters }) {
      await commit('setCalculation', getters.getPurchaseList)
    },
    // APIに購入確認ステータスでリクエスト
    async purchaseConfirm({ state, commit }) {
      const params = {
        type: 1, // 購入確認
        data: state.calculation,
        payment: state.options.payment,
        charge_name: state.options.charge_name
      }
      
      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setPurchaseConfirm', data)
            commit('setVisiblePopup', 'confirm')
          } else {
            commonErrorMessage(response)
          }
          return data
        })
    },
    closeConfirm({ commit }) {
      commit('setVisiblePopup', null)
    },
    async submitConfirm({ state, commit }) {
      const params = {
        type: 2, // 購入完了
        data: state.calculation,
        payment: state.options.payment,
        charge_name: state.options.charge_name
      }
      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setPurchaseConfirm', data)
            commit('setVisiblePopup', 'complete')
          } else {
            commonErrorMessage(response)
          }
          return data
        })
    },
    closeComplete({ commit }) {
      commit('setPurchaseConfirm', null)
      commit('setVisiblePopup', null)
    },
    async purchaseComplete({ state, commit }) {
      const params = {
        type: 2, // 購入完了
        data: state.calculation,
        payment: state.options.payment,
        charge_name: state.options.charge_name
      }
      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setPurchaseComplete', data)
          } else {
            commonErrorMessage(response)
          }
        })
    },
    resetAllState({ commit }) {
      commit('resetAllState')
    }
  }
}

export default purchase
